export default __webpack_public_path__ + "static/media/home-delivery-disabled.38572609.svg";